// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkIntegrationEntityMutationVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
  addedIntegrationEntityIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  removedIntegrationEntityIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  addeparLinkedToNongrantorEntity?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  groupIntegrationAssetValues?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LinkIntegrationEntityMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string, stage: Types.EntityStage, addeparLinkedToNongrantorEntity?: boolean | null, groupIntegrationAssetValues: boolean, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, integrationID: string }> | null } };

export type LinkIntegrationEntityDataQueryVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type LinkIntegrationEntityDataQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, groupIntegrationAssetValues: boolean, addeparLinkedToNongrantorEntity?: boolean | null, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, integrationID: string }> | null } | null } | null> | null } };

export const Operations = {
  Query: {
    LinkIntegrationEntityData: 'LinkIntegrationEntityData' as const
  },
  Mutation: {
    LinkIntegrationEntity: 'LinkIntegrationEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const LinkIntegrationEntityDocument = gql`
    mutation LinkIntegrationEntity($entityId: ID!, $addedIntegrationEntityIds: [ID!]!, $removedIntegrationEntityIds: [ID!]!, $addeparLinkedToNongrantorEntity: Boolean, $groupIntegrationAssetValues: Boolean) {
  updateEntity(
    input: {id: $entityId, update: {addIntegrationEntityIDs: $addedIntegrationEntityIds, removeIntegrationEntityIDs: $removedIntegrationEntityIds, addeparLinkedToNongrantorEntity: $addeparLinkedToNongrantorEntity, groupIntegrationAssetValues: $groupIntegrationAssetValues, stage: ACTIVE}}
  ) {
    id
    stage
    integrationEntities {
      id
      integrationID
    }
    addeparLinkedToNongrantorEntity
    groupIntegrationAssetValues
  }
}
    `;
export type LinkIntegrationEntityMutationFn = Apollo.MutationFunction<LinkIntegrationEntityMutation, LinkIntegrationEntityMutationVariables>;

/**
 * __useLinkIntegrationEntityMutation__
 *
 * To run a mutation, you first call `useLinkIntegrationEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkIntegrationEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkIntegrationEntityMutation, { data, loading, error }] = useLinkIntegrationEntityMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      addedIntegrationEntityIds: // value for 'addedIntegrationEntityIds'
 *      removedIntegrationEntityIds: // value for 'removedIntegrationEntityIds'
 *      addeparLinkedToNongrantorEntity: // value for 'addeparLinkedToNongrantorEntity'
 *      groupIntegrationAssetValues: // value for 'groupIntegrationAssetValues'
 *   },
 * });
 */
export function useLinkIntegrationEntityMutation(baseOptions?: Apollo.MutationHookOptions<LinkIntegrationEntityMutation, LinkIntegrationEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkIntegrationEntityMutation, LinkIntegrationEntityMutationVariables>(LinkIntegrationEntityDocument, options);
      }
export type LinkIntegrationEntityMutationHookResult = ReturnType<typeof useLinkIntegrationEntityMutation>;
export type LinkIntegrationEntityMutationResult = Apollo.MutationResult<LinkIntegrationEntityMutation>;
export type LinkIntegrationEntityMutationOptions = Apollo.BaseMutationOptions<LinkIntegrationEntityMutation, LinkIntegrationEntityMutationVariables>;
export const LinkIntegrationEntityDataDocument = gql`
    query LinkIntegrationEntityData($entityId: ID!) {
  entities(where: {id: $entityId}) {
    edges {
      node {
        ... on Entity {
          id
          kind
          groupIntegrationAssetValues
          addeparLinkedToNongrantorEntity
          integrationEntities {
            id
            integrationID
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLinkIntegrationEntityDataQuery__
 *
 * To run a query within a React component, call `useLinkIntegrationEntityDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkIntegrationEntityDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkIntegrationEntityDataQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useLinkIntegrationEntityDataQuery(baseOptions: Apollo.QueryHookOptions<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>(LinkIntegrationEntityDataDocument, withFetchPolicyContext(options));
      }
export function useLinkIntegrationEntityDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>(LinkIntegrationEntityDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLinkIntegrationEntityDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>(LinkIntegrationEntityDataDocument, withFetchPolicyContext(options));
        }
export type LinkIntegrationEntityDataQueryHookResult = ReturnType<typeof useLinkIntegrationEntityDataQuery>;
export type LinkIntegrationEntityDataLazyQueryHookResult = ReturnType<typeof useLinkIntegrationEntityDataLazyQuery>;
export type LinkIntegrationEntityDataSuspenseQueryHookResult = ReturnType<typeof useLinkIntegrationEntityDataSuspenseQuery>;
export type LinkIntegrationEntityDataQueryResult = Apollo.QueryResult<LinkIntegrationEntityDataQuery, LinkIntegrationEntityDataQueryVariables>;